import React from "react";
import { TableRow, TableCell, Skeleton } from "@mui/material";

type SkeletonProps = {
  columns: number;
  rows?: number;
};

const SkeletonTable = ({ columns, rows = 5 }: SkeletonProps) => {
  return (
    <>
      {Array.from({ length: rows }).map((_, rIndex) => (
        <TableRow key={rIndex}>
          {Array.from({ length: columns }).map((_, cIndex) => (
            <TableCell key={cIndex} align={cIndex === 0 ? "center" : "left"}>
              <Skeleton
                animation="wave"
                variant="rectangular"
                height={20}
                sx={{ borderRadius: "4px" }}
                width={cIndex === 0 ? 30 : "75%"}
              />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </>
  );
};

export default SkeletonTable;
